import api from '../../api'
import {
  GET_MANUFACTURE_LIST_SUCCESS,
  GET_MANUFACTURE_LIST_FAILURE,
  GET_MANUFACTURE_FAILURE,
  GET_MANUFACTURE_SUCCESS,
  UPDATE_MANUFACTURE_SUCCESS,
} from '../types'

const state = {
  list: [],
  listUpdated: (new Date()),
  toValidateList: [],
  selected: null,
  selectedUpdated: (new Date())
};


const actions = {
  getManufactureList({commit}, query) {
    return new Promise((resolve, reject) => {

    api.startLoader()
    api.getManufactureList(query).then(response => {
      if (!response.ok) {
        api.stopLoader()
        commit(GET_MANUFACTURE_LIST_FAILURE)
        return reject(response.body.$error)

      }
      commit(GET_MANUFACTURE_LIST_SUCCESS, {
        manufactureList: response.body.data
      })
      api.stopLoader()
      return resolve(response.body.data)

    }, response => {
      api.stopLoader()
      commit(GET_MANUFACTURE_LIST_FAILURE)
      return reject(response.body.$error)
    })
  })

  },
 
  cleanManufactureList({commit}) {
    return commit(GET_MANUFACTURE_LIST_FAILURE)
  },
  getManufacture({commit}, ud) {
    return new Promise((resolve, reject) => {

      api.getManufacture(ud)
        .then(response => {
          console.log(response);
          if (!response.ok) {
            commit(GET_MANUFACTURE_FAILURE);
            reject();
          }
          commit(GET_MANUFACTURE_SUCCESS, {
            manufacture: response.body
          });
          resolve(response.body);
        }, response => {
          commit(GET_MANUFACTURE_FAILURE);
          reject();
        })
    })
  },
 
  
  updateManufacture({commit}, data) {
    return new Promise((resolve, reject) => {

      api.startLoader()
      let avaliables = [
        "id",
        "name",
        "active"
      ];

      let obj = {};

      for (let i of avaliables) {
        if (data.hasOwnProperty(i)) {
          obj[i] = data[i];
        }
      }

          api.updateManufacture(obj)
            .then(response => {
              if (!response.ok) {
                api.stopLoader()
                return reject(response.body.$error);
              } else {
                api.stopLoader()
                return resolve(response.body.$success);
              }
            }, response => {
              api.stopLoader()
              return reject(response.body.$error);
            })
      
    })
  },


  createManufacture({commit}, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()
      api.createManufacture(data)
      .then(response => {
        if (!response.ok) {
          api.stopLoader()
          return reject(response.body.$error);
        } else {
          api.stopLoader()
          return resolve(response.body.$success);
        }
      }, response => {
        api.stopLoader()
        return reject(response.body.$error);
      })
    })
  },
  
  
 
  deleteManufacture({commit}, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()
      api.deleteManufacture(data)
         .then(response => {
              if (!response.ok) {
                api.stopLoader()
                return reject(response.body.$error);
              } else {
                api.stopLoader()
                return resolve(response.body.$success);
              }
            }, response => {
              api.stopLoader()
              return reject(response.body.$error);
            })
    })
  },

  
  
};

const mutations = {

  [UPDATE_MANUFACTURE_SUCCESS](state, action) {
    state.selected = JSON.parse(JSON.stringify(action.manufacture));
  },
  [GET_MANUFACTURE_LIST_FAILURE](state) {
    state.list = []
  },
  [GET_MANUFACTURE_LIST_SUCCESS](state, action) {
    state.list = action.manufactureList;
    state.listUpdated = new Date();
  },
  [GET_MANUFACTURE_FAILURE](state) {
    state.selected = null
  },
  [GET_MANUFACTURE_SUCCESS](state, action) {
    state.selected = JSON.parse(JSON.stringify(action.manufacture));
  },
};

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/manufacture.js